import {useSelector} from "react-redux";
import {NextOfKinForm} from "../../Forms/NextOfKinForm";
import { Alert } from "antd";

const NextOfKinModal = ({data, refresh}) => {
  // const {alert} = useSelector((state) => state.appData);

  return (
    <div
        id="emergency_contact_modal"
        className="modal custom-modal fade"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Next Of Kin Details</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">

              <NextOfKinForm empId={data?.id} profile={data} onNext={refresh} isEditing={true} />
            </div>
          </div>
        </div>
      </div>
  )
}
export default NextOfKinModal;
